import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SettingsComponents.css';

function InviteClientsSettings() {
    
    return (
        <div className="settings-component">
            <div className="settings-header">
                <div className="settings-title-group">
                    <h1 className="settings-title">Invite Clients</h1>
                    <h2 className="settings-subtitle">Invite clients to your workspace</h2>
                </div>
            </div>
            <div className="content" style={{
                borderRadius: '8px',
                padding: '40px',
                textAlign: 'center',
                marginTop: '20px'
            }}>
                <div style={{
                    fontSize: '48px',
                    color: '#6c757d',
                    marginBottom: '16px'
                }}>
                    🪪
                </div>
                <h3 style={{
                    color: '#495057',
                    marginBottom: '8px',
                    fontSize: '20px'
                }}>
                    Invite Clients
                </h3>
                <p style={{
                    color: '#6c757d',
                    fontSize: '16px',
                    margin: '0',
                    marginTop: '20px'
                }}>
                    Ability to manager client invitations / workspace access coming soon!
                </p>
            </div>
        </div>
    );
}

export default InviteClientsSettings;